import React from "react";
import { FactoryIcon, TruckIcon, SettingsIcon, PackageIcon, Building2Icon, ShieldCheckIcon, BoxesIcon, HandshakeIcon } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { SectionHeading } from "../ui/SectionHeading";
import { Reveal } from "../ui/Reveal";
const icons = [FactoryIcon, TruckIcon, SettingsIcon, PackageIcon, Building2Icon, ShieldCheckIcon, BoxesIcon, HandshakeIcon];
export function Capacity() {
  const {
    t
  } = useLanguage();
  return <section id="capacidad" className="w-full bg-navy py-20 sm:py-28" data-id="element-148" data-mp="18se7bj8bpuu2">
      <div className="max-w-content mx-auto px-4 sm:px-6" data-id="element-149" data-mp="1dke3d0l9w3ld">
        <SectionHeading eyebrow={t.capacity.eyebrow} title={t.capacity.title} subtitle={t.capacity.subtitle} invert data-id="element-150" data-mp="1dn09qwwfgd20" />

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5" data-id="element-151" data-mp="1nkeoms2pcts7">
          {t.capacity.items.map((item, i) => {
          const Icon = icons[i % icons.length];
          return <Reveal key={item.label} delay={i % 4 * 0.05} data-id="element-152" data-mp="3p5otxk7kn92m" data-mpi={i}>
                <div className="h-full bg-navy-light/40 border border-white/10 rounded-sm p-6 text-center transition-colors hover:border-orange/60" data-id="element-153" data-mp="3k512wyjces8e">
                  <span className="inline-flex h-14 w-14 items-center justify-center rounded-sm bg-orange/15 text-orange" data-id="element-154" data-mp="3f8aftr94ewdh">
                    <Icon size={28} data-id="element-155" data-mp="bp7ocp8knqtz" />
                  </span>
                  <p className="mt-4 font-heading font-bold uppercase text-white text-2xl leading-none" data-id="element-156" data-mp="boph6xkdfs7a">
                    {item.value}
                  </p>
                  <p className="mt-2 text-sm text-slate-300 leading-snug" data-id="element-157" data-mp="1yw6dys1zh43">{item.label}</p>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}